import React from "react";
import {Card} from "antd";
import SearchForm from "./SearchForm";
import SummaryList from "./SummaryList";
export default function () {
    return (
        <>
            <Card
                bordered={true}
                className="margin-top-8"
                style={{display: "flex"}}
            >
                <div
                    style={{
                        margin: "8px 20px"
                    }}
                >
                    <SearchForm/>
                </div>
            </Card>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <SummaryList/>
            </Card>
        </>
    )
}